import { graphStore } from "../graph-store"
import type { ViewManifest } from "../views/manifest"

const DEFAULT_TITLE = "Spaestiem"

export function setupViewTitle(view: ViewManifest): void {
  // Generation counter prevents an in-flight relevance() from overwriting
  // a newer title when store events fire in quick succession.
  let generation = 0

  const update = async () => {
    const myGen = ++generation
    if (!view.relevance) {
      document.title = view.label
      return
    }
    try {
      const label = await view.relevance(graphStore)
      if (myGen !== generation) return
      document.title = label ?? DEFAULT_TITLE
    } catch (e) {
      console.error("view-title: relevance failed", e)
      if (myGen === generation) document.title = view.label
    }
  }

  void update()
  document.addEventListener("store-updated", update)
  document.addEventListener("store-cleared", update)
}
